import React from 'react';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import CircularProgress from '@mui/material/CircularProgress';

/**
 * Dialog for creating a new folder in the source package
 */
export default function CreateFolderDialog({
                                               open,
                                               onClose,
                                               onCreateFolder,
                                           }) {
    const [folderName, setFolderName] = React.useState('');
    const [submitting, setSubmitting] = React.useState(false);
    const inputRef = React.useRef(null);

    React.useEffect(() => {
        if (open && inputRef.current) {
            inputRef.current.focus();
        }
    }, [open]);

    const handleCreate = async () => {
        const name = (folderName || '').trim();
        if (!name) return;

        try {
            setSubmitting(true);
            await onCreateFolder(name);
            setFolderName('');
            onClose();
        } catch (e) {
            console.error('Failed to create folder:', e);
            throw e;
        } finally {
            setSubmitting(false);
        }
    };

    const handleClose = () => {
        if (!submitting) {
            setFolderName('');
            onClose();
        }
    };

    return (
        <Dialog open={open} onClose={handleClose} sx={{zIndex: 11000}}>
            <DialogTitle>Enter folder name</DialogTitle>
            <DialogContent>
                <TextField
                    inputRef={inputRef}
                    autoFocus
                    fullWidth
                    margin="dense"
                    label="Folder name"
                    value={folderName}
                    onChange={(e) => setFolderName(e.target.value)}
                    onKeyDown={(e) => {
                        if (e.key === 'Enter') {
                            e.preventDefault();
                            handleCreate();
                        }
                    }}
                />
            </DialogContent>
            <DialogActions>
                <Button onClick={handleClose} disabled={submitting}>
                    Cancel
                </Button>
                <Button
                    onClick={handleCreate}
                    disabled={submitting || !folderName.trim()}
                    variant="contained"
                    endIcon={submitting ? <CircularProgress size={16}/> : null}
                >
                    Create
                </Button>
            </DialogActions>
        </Dialog>
    );
}
